if (!customElements.get('collection-description')) {
  customElements.define('collection-description', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.text = this.querySelector('[data-collection-about-text]');
      this.button = this.querySelector('[data-collection-about-toggle]');
      if (!this.text || !this.button) return;
      this.controller = new AbortController();
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.measure());
      };
      this.button.addEventListener('click', () => {
        this.classList.toggle('is-open');
        this.updateButton();
      }, { signal: this.controller.signal });
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this);
      this.observer.observe(this.text);
      document.fonts?.ready.then(() => { if (this.isConnected) this.schedule(); });
      document.fonts?.addEventListener('loadingdone', this.schedule, { signal: this.controller.signal });
      this.schedule();
    }
    measure() {
      const wasOpen = this.classList.contains('is-open');
      this.classList.remove('is-open');
      this.classList.add('is-collapsible');
      const lineHeight = parseFloat(getComputedStyle(this.text).lineHeight) || 24;
      const overflows = this.text.scrollHeight - this.text.clientHeight > lineHeight * 2;
      this.classList.toggle('is-collapsible', overflows);
      this.classList.toggle('is-open', overflows && wasOpen);
      this.button.hidden = !overflows;
      this.updateButton();
    }
    updateButton() {
      const open = this.classList.contains('is-open');
      this.button.setAttribute('aria-expanded', String(open));
      this.button.textContent = open ? this.button.dataset.labelLess : this.button.dataset.labelMore;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
